import { useEffect, useState } from 'react';
import { apiRequest } from '../../api/client';
import './CastRow.css';

const headshot = (path: string) => `https://image.tmdb.org/t/p/w185${path}`;
const initials = (name: string) => name.split(' ').map(part => part[0]).join('').slice(0, 2);

// Top-billed cast with a heart to mark favourite actors (saved to the account and shown on My films).
const CastRow = ({ cast, directors, signedIn }: { cast: any[]; directors: any[]; signedIn: boolean }) => {
  const [favourites, setFavourites] = useState<Set<number>>(new Set());
  useEffect(() => {
    if (!signedIn) return;
    apiRequest<any>('/actors/favourites').then(data => setFavourites(new Set((data.items || []).map((item: any) => Number(item.personId))))).catch(() => undefined);
  }, [signedIn]);
  const toggle = async (person: any) => {
    const on = favourites.has(person.id);
    setFavourites(current => { const next = new Set(current); on ? next.delete(person.id) : next.add(person.id); return next; });
    await apiRequest(`/actors/favourites/${person.id}`, on ? { method: 'DELETE' } : { method: 'PUT', body: JSON.stringify({ name: person.name, profilePath: person.profilePath }) }).catch(() => undefined);
  };
  if (!cast?.length) return null;
  return <section className="cast-row" aria-labelledby="cast-heading">
    <div className="cast-row__heading"><h2 id="cast-heading">Cast</h2>{directors?.length > 0 && <span>Directed by <strong>{directors.map(person => person.name).join(', ')}</strong></span>}</div>
    <div className="cast-row__list">{cast.slice(0, 12).map(person => <article key={person.id} className="cast-card">
      {person.profilePath ? <img src={headshot(person.profilePath)} alt="" loading="lazy" /> : <span className="cast-card__blank" aria-hidden="true">{initials(person.name)}</span>}
      <strong>{person.name}</strong><small>{person.character}</small>
      {signedIn && <button className={`cast-card__fav${favourites.has(person.id) ? ' is-on' : ''}`} onClick={() => toggle(person)} aria-pressed={favourites.has(person.id)} aria-label={`${favourites.has(person.id) ? 'Remove' : 'Add'} ${person.name} ${favourites.has(person.id) ? 'from' : 'to'} favourite actors`}>{favourites.has(person.id) ? '♥' : '♡'}</button>}
    </article>)}</div>
    {signedIn && <p className="cast-row__hint">Tap ♡ on actors you love. We’ll use them to find films you’ll like.</p>}
  </section>;
};

export default CastRow;
